module.exports = __webpack_public_path__ + "img/390cb35.png";